export default "__VITE_ASSET__DFuwZENp__"